// extracted by mini-css-extract-plugin
module.exports = {"contentDisplay":"RetailerWidgetTextContentSettings_contentDisplay__zI1s5"};